module.exports = __webpack_public_path__ + "img/help.5b46f938.gif";